// extracted by mini-css-extract-plugin
export var headerCell = "_5c-1";
export var loadingSpinnerContainer = "_5c-4";
export var rowWrapper = "_5c-3";
export var standaloneTable = "_5c-5";
export var table = "_5c-0";
export var white = "_5c-2";